import { Component, Inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigStorage, UserStorage } from "@scisys-uim/uim-common";
import { FIREARM_TYPE } from "assets-model";
import { FirearmAssignablePersonService, FirearmAssignmentLogService, FirearmPoolService, FirearmService, FirearmStorageLocationService } from "assets-service";
import { FirearmStorageAssignmentCreationDialogComponent, FirearmStorageAssignmentCreationDialogConfigData, FirearmStorageAssignmentCreationDialogData } from "./firearm-storage-assignment-creation-dialog.component";



export interface FirearmSuspendDialogData extends FirearmStorageAssignmentCreationDialogData {
}

export interface FirearmSuspendDialogConfigData extends FirearmStorageAssignmentCreationDialogConfigData {
}

@Component({
  selector: 'app-firearm-suspend-dialog',
  templateUrl: './firearm-suspend-dialog.component.html',
  styleUrls: ['./firearm-suspend-dialog.component.scss']
})
export class FirearmSuspendDialogComponent extends FirearmStorageAssignmentCreationDialogComponent {

  get firearmTypeName(): string {
    return FIREARM_TYPE.typeName(this.data?.firearm);
  }

  constructor(
    dialogRef: MatDialogRef<FirearmSuspendDialogComponent, FirearmSuspendDialogData>,
    @Inject(MAT_DIALOG_DATA) data: FirearmSuspendDialogConfigData,
    fb: FormBuilder,
    dialog: MatDialog,
    firearmService: FirearmService,
    firearmAssignmentLogService: FirearmAssignmentLogService,
    firearmAssignablePersonService: FirearmAssignablePersonService,
    firearmStorageLocationService: FirearmStorageLocationService,
    firearmPoolService: FirearmPoolService,
    configService: ConfigStorage,
    userStorage: UserStorage) {
    super(dialogRef, data, fb, dialog, firearmService, firearmAssignmentLogService, firearmAssignablePersonService, firearmStorageLocationService, firearmPoolService, configService, userStorage);
  }

  protected isStorageAssigneeRequired() {
    return this.currentlyIssued;
  }
  protected isLocationRequired() {
    return this.currentlyIssued;
  }
  protected isCommentRequired() {
    return this.currentlyIssued;
  }

  isFirearmSuspendEnabled() {
    return this.isFirearmStorageAssignmentCreationEnabled();
  }

  firearmSuspend() {
    this.firearmService.suspendFirearm({
      assetId: this.data.firearm?.assetId,
      storageAssignee: {
        personId: this.item?.storageAssignee?.personId,
        username: this.item?.storageAssignee?.user?.user
      },
      locationId: this.item?.location?.firearmStorageLocationId,
      comments: this.item.comments
    }).subscribe(result => {
      this.item.firearm = result;
      this.dialogRef.close(this.item);
    });
  }

}